import { useAuth } from "@/modules/auth";

export function Logout() {
  const { logout } = useAuth();
  // TODO: logout button should not be a anchor tag
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  return <a onClick={logout}>Logout</a>;
}
